import { inject, Injectable } from '@angular/core';
import { chooseFn, inputFn } from '@softline/ui-core';
import { Template } from '../../user/templates/template';
import { TemplateOptionComponent } from '../components/template-option/template-option.component';
import { TemplateRepository } from '../repositories/template.repository';

@Injectable({ providedIn: 'root' })
export class TemplateService {
  private repository = inject(TemplateRepository);
  private choose = chooseFn();
  private input = inputFn();

  async select<T>(group: string): Promise<Template<T> | null> {
    const templates = await this.repository.loadGroup<T>(group);
    const result = await this.choose({
      title: 'Vorlage auswählen',
      options: templates.map((o) => ({ value: o })),
      optionComponent: TemplateOptionComponent<T>,
    });
    if (result === 'DISMISSED') return null;
    return result;
  }

  async add<T>(group: string, value: T): Promise<void> {
    const title = await this.input({
      title: 'Vorlage speichern',
      textValue: '',
      multiline: false,
    });
    if (title === 'DISMISSED') return;
    const template: Template<T> = {
      id: crypto.randomUUID(),
      title,
      group,
      timestamp: new Date().toISOString(),
      value,
    };
    await this.repository.create(template);
  }
}
